import { useState, useEffect, useCallback } from "react";
import {
  CheckboxField as ACheckboxField,
  TextField as ATextField,
  Flex,
  Card,
  Heading,
} from "@aws-amplify/ui-react";
import { Button, Container } from "react-bootstrap";
import { Notification } from "../Notification/Notification";
import { Modal } from "../Modal/Modal";
import {
  CreateAppConfigMutationVariables,
  UpdateAppConfigMutationVariables,
  useCreateAppConfigMutation,
  useGetAppConfigQuery,
  useUpdateAppConfigMutation,
} from "../../graphql/generated/graphql";
import { ToggleCard } from "../_shared/ToggleCard";

export default function FeatureFlags() {
  const [loaded, setLoaded] = useState<boolean>(false);
  const [disableTI, setDisableTI] = useState<boolean>(false);
  const [disableTMC, setDisableTMC] = useState<boolean>(false);
  const [disableApp, setDisableApp] = useState<boolean>(false);
  const [disableTIPurchase, setDisableTIPurchase] = useState<boolean>(false);
  const [disableTICancellation, setDisableTICancellation] =
    useState<boolean>(false);
  const [disableTIRenewals, setDisableTIRenewals] = useState<boolean>(false);
  const [disabledMessageTI, setDisabledMessageTI] = useState<string>("");
  const [disabledMessageTIPurchase, setDisabledMessageTIPurchase] =
    useState<string>("");
  const [disabledMessageTICancellation, setDisabledMessageTICancellation] =
    useState<string>("");
  const [disabledMessageTIRenewals, setDisabledMessageTIRenewals] =
    useState<string>("");
  const [tiStartDate, setTIStartDate] = useState(new Date() as Date);
  const [tiEndDate, setTIEndDate] = useState(new Date() as Date);
  const [tmcStartDate, setTMCStartDate] = useState(new Date() as Date);
  const [tmcEndDate, setTMCEndDate] = useState(new Date() as Date);
  const [appFuncStartDate, setAppFuncStartDate] = useState(new Date() as Date);
  const [appFuncEndDate, setAppFuncEndDate] = useState(new Date() as Date);
  const [disabledMessageTMC, setDisabledMessageTMC] = useState<string>("");
  const [disabledMessageApp, setDisabledMessageApp] = useState<string>("");
  const [minimumAppVersion, setMinimumAppVersion] = useState<string>("");
  const [useUpdateFunction, setUseUpdateFunction] = useState<boolean>(false);
  const [showToast, setShowToast] = useState(false as boolean);
  const [toastTitle, setToastTitle] = useState("" as string);
  const [toastDescription, setToastDescription] = useState("" as string);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [enableJuneAutorenewChanges, setEnableJuneAutorenewChanges] =
    useState<boolean>(false);
  const [enableCurrencyConverter, setEnableCurrencyConverter] =
    useState<boolean>(false);
  const [enableReferral, setEnableReferral] = useState<boolean>(false);
  const [enableTrustpilot, setEnableTrustpilot] = useState<boolean>(false);
  const [enableApplepay, setEnableApplepay] = useState<boolean>(false);
  const [enableGooglepay, setEnableGooglepay] = useState<boolean>(false);
  const [enableFresApiV2, setEnableFresApiV2] = useState<boolean>(false);
  const [enablePayByBank, setEnablePayByBank] = useState<boolean>(false);

  const { data, loading} = useGetAppConfigQuery();
  const [createAppConfig] = useCreateAppConfigMutation();
  const [updateAppConfig] = useUpdateAppConfigMutation();

  const fetchAppConfig = useCallback(async () => {

    if (!data) return;

    try {
      console.log("fetchAppConfig - fetching app config with data: ", data);

      const items = data?.getAppConfig;

      console.log("fetchAppConfig - fetched app config: ", items);

      if (!items || items.length === 0) {
        setUseUpdateFunction(false);
      } else {
        setUseUpdateFunction(true);
      }
      setDisableTI(items[0].disableTI);
      setTIStartDate(new Date(items[0].tiStartDate));
      setTIEndDate(new Date(items[0].tiEndDate));
      setTMCStartDate(new Date(items[0].tmcStartDate));
      setTMCEndDate(new Date(items[0].tmcEndDate));
      setAppFuncStartDate(new Date(items[0].appFuncStartDate));
      setAppFuncEndDate(new Date(items[0].appFuncEndDate));
      setDisableTMC(items[0].disableTMC);
      setDisableApp(items[0].disableApp);
      setDisableTIPurchase(items[0].disableTIPurchase);
      setDisableTICancellation(items[0].disableTICancellation);
      setDisableTIRenewals(items[0].disableTIRenewals);
      setDisabledMessageTI(items[0].disabledMessageTI);
      setDisabledMessageTMC(items[0].disabledMessageTMC);
      setDisabledMessageApp(items[0].disabledMessageApp);
      setMinimumAppVersion(items[0].minimumAppVersion);
      setDisabledMessageTIPurchase(items[0].disabledMessageTIPurchase);
      setDisabledMessageTICancellation(items[0].disabledMessageTICancellation);
      setDisabledMessageTIRenewals(items[0].disabledMessageTIRenewals);
      setEnableJuneAutorenewChanges(items[0].enableJuneAutorenewChanges);
      setEnableCurrencyConverter(items[0].enableCurrencyConverter);
      setEnableReferral(items[0].enableReferral);
      setEnableTrustpilot(items[0].enableTrustpilot);
      setEnableApplepay(items[0].enableApplepay);
      setEnableGooglepay(items[0].enableGooglepay);
      setEnableFresApiV2(items[0].enableFresApiV2);
      setEnablePayByBank(items[0].enablePayByBank);
    } catch (e) {
      console.log("error fetching app config: ", e);
    }
  }, [data]);


useEffect(() => {
  if (!loading && data) {
    fetchAppConfig();
    setLoaded(true);
  }
}, [loading, data, fetchAppConfig]);


  useEffect(() => {
    setLoaded(true);
    if (data && data.getAppConfig.length > 0) {
      const currentDate = new Date();
      const appConfig = data.getAppConfig[0];

      const tiEnd = new Date(appConfig.tiEndDate);
      if (currentDate.getTime() > tiEnd.getTime() && appConfig.disableTI) {
        setDisableTI(false);
      }

      const tmcEnd = new Date(appConfig.tmcEndDate);
      if (currentDate.getTime() > tmcEnd.getTime() && appConfig.disableTMC) {
        setDisableTMC(false);
      }

      const appFuncEnd = new Date(appConfig.appFuncEndDate);
      if (
        currentDate.getTime() > appFuncEnd.getTime() &&
        appConfig.disableApp
      ) {
        setDisableApp(false);
      }

      //updating the new changes to app config (if available)
      if (
        (tiEnd < currentDate && appConfig.disableTI) ||
        (tmcEnd < currentDate && appConfig.disableTMC) ||
        (appFuncEnd < currentDate && appConfig.disableApp)
      ) {
        const updateAppConfigOnDatePass = async () => {
          try {
            const variables: UpdateAppConfigMutationVariables = {
              appConfig: {
                id: "0",
                disableTI: tiEnd < currentDate ? false : appConfig.disableTI,
                tiStartDate: appConfig.tiStartDate,
                tiEndDate: appConfig.tiEndDate,
                tmcStartDate: appConfig.tmcStartDate,
                tmcEndDate: appConfig.tmcEndDate,
                appFuncStartDate: appConfig.appFuncStartDate,
                appFuncEndDate: appConfig.appFuncEndDate,
                disableTMC: tmcEnd < currentDate ? false : appConfig.disableTMC,
                disableApp:
                  appFuncEnd < currentDate ? false : appConfig.disableApp,
                disableTIPurchase: appConfig.disableTIPurchase,
                disableTICancellation: appConfig.disableTICancellation,
                disableTIRenewals: appConfig.disableTIRenewals,
                disabledMessageTI: appConfig.disabledMessageTI,
                disabledMessageTMC: appConfig.disabledMessageTMC,
                disabledMessageApp: appConfig.disabledMessageApp,
                minimumAppVersion: appConfig.minimumAppVersion,
                disabledMessageTIPurchase: appConfig.disabledMessageTIPurchase,
                disabledMessageTICancellation:
                  appConfig.disabledMessageTICancellation,
                disabledMessageTIRenewals: appConfig.disabledMessageTIRenewals,
                enableJuneAutorenewChanges:
                  appConfig.enableJuneAutorenewChanges,
                enableCurrencyConverter: appConfig.enableCurrencyConverter,
                enableReferral: appConfig.enableReferral,
                enableTrustpilot: appConfig.enableTrustpilot,
                enableApplepay: appConfig.enableApplepay,
                enableGooglepay: appConfig.enableGooglepay,
                enableFresApiV2: appConfig.enableFresApiV2,
                enablePayByBank: appConfig.enablePayByBank,
              },
            };
            await updateAppConfig({ variables });
            console.log("app config updated after end date passed");
          } catch (e) {
            console.log("error updating app config after end date passed");
          }
        };
        updateAppConfigOnDatePass();
      }
    }
  }, [data, updateAppConfig]);

  const toastVariant = toastTitle === "Error!" ? "danger" : "success";

  const createAppConfigFunc = async () => {
    try {
      const variables: CreateAppConfigMutationVariables = {
        appConfig: {
          id: "0",
          disableTI: disableTI,
          tiStartDate: new Date(tiStartDate).toISOString(),
          tiEndDate: new Date(tiEndDate).toISOString(),
          tmcStartDate: new Date(tmcStartDate).toISOString(),
          tmcEndDate: new Date(tmcEndDate).toISOString(),
          appFuncStartDate: new Date(appFuncStartDate).toISOString(),
          appFuncEndDate: new Date(appFuncEndDate).toISOString(),
          disableTMC: disableTMC,
          disableApp: disableApp,
          disableTIPurchase: disableTIPurchase,
          disableTICancellation: disableTICancellation,
          disableTIRenewals: disableTIRenewals,
          disabledMessageTI: disabledMessageTI,
          disabledMessageTMC: disabledMessageTMC,
          disabledMessageApp: disabledMessageApp,
          minimumAppVersion: minimumAppVersion,
          disabledMessageTIPurchase: disabledMessageTIPurchase,
          disabledMessageTICancellation: disabledMessageTICancellation,
          disabledMessageTIRenewals: disabledMessageTIRenewals,
          enableJuneAutorenewChanges: enableJuneAutorenewChanges,
          enableCurrencyConverter: enableCurrencyConverter,
          enableReferral: enableReferral,
          enableTrustpilot: enableTrustpilot,
          enableApplepay: enableApplepay,
          enableGooglepay: enableGooglepay,
          enableFresApiV2: enableFresApiV2,
          enablePayByBank: enablePayByBank,
        },
      };
      await createAppConfig({ variables });
      return "success";
    } catch (e) {
      console.log("error creating app config: ", e);
    }
  };

  const updateAppConfigFunc = async () => {
    try {
      const variables: UpdateAppConfigMutationVariables = {
        appConfig: {
          id: "0",
          disableTI: disableTI,
          tiStartDate: new Date(tiStartDate).toISOString(),
          tiEndDate: new Date(tiEndDate).toISOString(),
          tmcStartDate: new Date(tmcStartDate).toISOString(),
          tmcEndDate: new Date(tmcEndDate).toISOString(),
          appFuncStartDate: new Date(appFuncStartDate).toISOString(),
          appFuncEndDate: new Date(appFuncEndDate).toISOString(),
          disableTMC: disableTMC,
          disableApp: disableApp,
          disableTIPurchase: disableTIPurchase,
          disableTICancellation: disableTICancellation,
          disableTIRenewals: disableTIRenewals,
          disabledMessageTI: disabledMessageTI,
          disabledMessageTMC: disabledMessageTMC,
          disabledMessageApp: disabledMessageApp,
          minimumAppVersion: minimumAppVersion,
          disabledMessageTIPurchase: disabledMessageTIPurchase,
          disabledMessageTICancellation: disabledMessageTICancellation,
          disabledMessageTIRenewals: disabledMessageTIRenewals,
          enableJuneAutorenewChanges: enableJuneAutorenewChanges,
          enableCurrencyConverter: enableCurrencyConverter,
          enableReferral: enableReferral,
          enableTrustpilot: enableTrustpilot,
          enableApplepay: enableApplepay,
          enableGooglepay: enableGooglepay,
          enableFresApiV2: enableFresApiV2,
          enablePayByBank: enablePayByBank,
        },
      };
      await updateAppConfig({ variables });
      return "success";
    } catch (e) {
      console.log("error updating app config: ", e);
    }
  };

  const handleCreateAppConfig = async () => {
    const result = await createAppConfigFunc();
    if (result === "success") {
      setToastTitle("Success!");
      setToastDescription("You successfully created the application config");
      setShowToast(true);
    } else {
      setToastTitle("Error!");
      setToastDescription("App config failed to create");
      setShowToast(true);
    }
    setShowCreateModal(false);
  };

  const handleUpdateAppConfig = async () => {
    const config = {
      id: "0",
      disableTI: disableTI,
      tiStartDate: new Date(tiStartDate).toISOString(),
      tiEndDate: new Date(tiEndDate).toISOString(),
      tmcStartDate: new Date(tmcStartDate).toISOString(),
      tmcEndDate: new Date(tmcEndDate).toISOString(),
      appFuncStartDate: new Date(appFuncStartDate).toISOString(),
      appFuncEndDate: new Date(appFuncEndDate).toISOString(),
      disableTMC: disableTMC,
      disableApp: disableApp,
      disableTIPurchase: disableTIPurchase,
      disableTICancellation: disableTICancellation,
      disableTIRenewals: disableTIRenewals,
      disabledMessageTI: disabledMessageTI,
      disabledMessageTMC: disabledMessageTMC,
      disabledMessageApp: disabledMessageApp,
      minimumAppVersion: minimumAppVersion,
      disabledMessageTIPurchase: disabledMessageTIPurchase,
      disabledMessageTICancellation: disabledMessageTICancellation,
      disabledMessageTIRenewals: disabledMessageTIRenewals,
      enableJuneAutorenewChanges: enableJuneAutorenewChanges,
      enableCurrencyConverter: enableCurrencyConverter,
      enableReferral: enableReferral,
      enableTrustpilot: enableTrustpilot,
      enableApplepay: enableApplepay,
      enableGooglepay: enableGooglepay,
      enableFresApiV2: enableFresApiV2,
      enablePayByBank: enablePayByBank,
    };
    console.log("updating app config with: ", config);
    const result = await updateAppConfigFunc();
    if (result === "success") {
      setToastTitle("Success!");
      setToastDescription("You successfully updated the application config");
      setShowToast(true);
    } else {
      setToastTitle("Error!");
      setToastDescription("App config failed to update");
      setShowToast(true);
    }
    setShowUpdateModal(false);
  };

  const handleNotificationClose = () => {
    setShowToast(false);
  };

  const handleCloseUpdateModal = () => {
    setShowUpdateModal(false);
  };

  const handleCloseCreateModal = () => {
    setShowCreateModal(false);
  };

  const handleStartDate = (value: Date, type: string) => {
    console.log("handling start date: ", value);
    if (value) {
      let convertedStartDate = new Date(value);
      switch (type) {
        case "ti":
          setTIStartDate(convertedStartDate);
          break;
        case "tmc":
          setTMCStartDate(convertedStartDate);
          break;
        case "appFunc":
          setAppFuncStartDate(convertedStartDate);
          break;
        default:
          break;
      }
    }
  };

  const handleEndDate = (value: Date, type: string) => {
    if (value) {
      let convertedEndDate = new Date(value);
      switch (type) {
        case "ti":
          setTIEndDate(convertedEndDate);
          break;
        case "tmc":
          setTMCEndDate(convertedEndDate);
          break;
        case "appFunc":
          setAppFuncEndDate(convertedEndDate);
          break;
        default:
          break;
      }
    }
  };

  const appFeatures = [
    {
      label: "Enable the June 17th TI autorenew changes",
      checked: enableJuneAutorenewChanges,
      onChangeFunc: setEnableJuneAutorenewChanges,
    },
    {
      label: "Enable Google Pay on 'Pay Now' page",
      checked: enableGooglepay,
      onChangeFunc: setEnableGooglepay,
    },
    {
      label: "Enable Apple Pay on 'Pay Now' page",
      checked: enableApplepay,
      onChangeFunc: setEnableApplepay,
    },
    {
      label: "Enable Pay by Bank",
      checked: enablePayByBank,
      onChangeFunc: setEnablePayByBank,
    },
    {
      label: "Enable Currency Converter",
      checked: enableCurrencyConverter,
      onChangeFunc: setEnableCurrencyConverter,
    },
    {
      label: "Enable 'Refer a friend'",
      checked: enableReferral,
      onChangeFunc: setEnableReferral,
    },
    {
      label: "Enable TrustPilot",
      checked: enableTrustpilot,
      onChangeFunc: setEnableTrustpilot,
    },
    {
      label: "Enable Fres API V2",
      checked: enableFresApiV2,
      onChangeFunc: setEnableFresApiV2,
    },
  ];

  return (
    <Container fluid style={{ marginLeft: 30 }}>
      <div className="outer-card">
        <Flex direction="column" gap="1.5rem">
          <Heading level={2} className="screen-title">
            App Config
          </Heading>

          {loaded && (
            <div>
              <Card
                variation="outlined"
                style={{ marginTop: 10 }}
                className="card"
              >
                <div className="info-text">{`Checked = disabled`}</div>
                <ToggleCard
                  hasDates={true}
                  startDate={tiStartDate}
                  endDate={tiEndDate}
                  handleStartDate={(event) =>
                    handleStartDate(event as Date, "ti")
                  }
                  handleEndDate={(event) => handleEndDate(event as Date, "ti")}
                  name="subscribe-controlled"
                  enabled={disableTI}
                  onChange={(checked: boolean, message: string) => {
                    setDisableTI(checked);
                    setDisabledMessageTI(message);
                  }}
                  label="Travel Insurance"
                  description="Disable Travel Insurance functionality in the app."
                  messageDefault={disabledMessageTI || "TI disabled"}
                />

                <ToggleCard
                  hasDates={true}
                  startDate={tmcStartDate}
                  endDate={tmcEndDate}
                  handleStartDate={(event) =>
                    handleStartDate(event as Date, "tmc")
                  }
                  handleEndDate={(event) => handleEndDate(event as Date, "tmc")}
                  name="disableTMC"
                  enabled={disableTMC}
                  onChange={(checked: boolean, message: string) => {
                    setDisableTMC(checked);
                    setDisabledMessageTMC(message);
                  }}
                  label="Travel Money Card"
                  description="Disable Travel Money Card functionality in the app."
                  messageDefault={disabledMessageTMC || "TMC disabled"}
                />
                <ToggleCard
                  hasDates={true}
                  startDate={appFuncStartDate}
                  endDate={appFuncEndDate}
                  handleStartDate={(event) =>
                    handleStartDate(event as Date, "appFunc")
                  }
                  handleEndDate={(event) =>
                    handleEndDate(event as Date, "appFunc")
                  }
                  name="subscribe-controlled"
                  enabled={disableApp}
                  onChange={(checked: boolean, message: string) => {
                    setDisableApp(checked);
                    setDisabledMessageApp(message);
                  }}
                  label="App functionality (user cannot proceed past passcode page)"
                  description="Disable Travel Insurance functionality in the app."
                  messageDefault={
                    disabledMessageApp || "All app functionalities disabled"
                  }
                />

                <ToggleCard
                  hasDates={false}
                  name="subscribe-controlled"
                  enabled={disableTIPurchase}
                  onChange={(checked: boolean, message: string) => {
                    setDisableTIPurchase(checked);
                    setDisabledMessageTIPurchase(message);
                  }}
                  label="Purchases of new policy of Travel Insurance"
                  description="Disable Travel Insurance functionality in the app."
                  messageDefault={
                    disabledMessageTIPurchase ||
                    "Purchase of new policy of Travel Insurance disabled"
                  }
                />

                <ToggleCard
                  hasDates={false}
                  name="subscribe-controlled"
                  enabled={disableTICancellation}
                  onChange={(checked: boolean, message: string) => {
                    setDisableTICancellation(checked);
                    setDisabledMessageTICancellation(message);
                  }}
                  label="TI Cancellation"
                  description="Disable Cancellations of Travel Insurance policies in app (checked = disabled)"
                  messageDefault={
                    disabledMessageTICancellation || "TI Cancellation disabled"
                  }
                />
                <ToggleCard
                  hasDates={false}
                  name="subscribe-controlled"
                  enabled={disableTIRenewals}
                  onChange={(checked: boolean, message: string) => {
                    setDisableTIRenewals(checked);
                    setDisabledMessageTIRenewals(message);
                  }}
                  label="TI Renewals"
                  description="Disable Renewals of Travel Insurance policies in app (checked = disabled)"
                  messageDefault={
                    disabledMessageTIRenewals || "TI Renewals disabled"
                  }
                />
              </Card>

              <Card
                variation="outlined"
                style={{ marginTop: 10 }}
                className="card"
              >
                <div className="info-text">{`Checked = enabled`}</div>
                {appFeatures.map((feature, _index) => {
                  return (
                    <div style={{ marginTop: 20 }}>
                      <ACheckboxField
                        name="subscribe-controlled"
                        value="yes"
                        size="large"
                        checked={feature.checked}
                        onChange={(e) => feature.onChangeFunc(e.target.checked)}
                        label={feature.label}
                      />
                    </div>
                  );
                })}
              </Card>
              <div style={{ marginTop: 20 }}>
                <ATextField
                  size="large"
                  autoComplete="off"
                  descriptiveText=""
                  direction="column"
                  hasError={false}
                  inputMode="text"
                  isDisabled={false}
                  isReadOnly={false}
                  isRequired={true}
                  label="Minimum App Version"
                  labelHidden={false}
                  name="last_name"
                  placeholder=""
                  type="number"
                  wrap="nowrap"
                  className="config-input"
                  value={minimumAppVersion}
                  onChange={(e: any) =>
                    setMinimumAppVersion(e.currentTarget.value)
                  }
                />
              </div>
            </div>
          )}
          {useUpdateFunction ? (
            <Button
              type="button"
              variant="primary"
              className="btn btn-primary"
              style={{ marginTop: 40, alignSelf: "flex-end" }}
              onClick={() => setShowUpdateModal(true)}
            >
              Update App Config
            </Button>
          ) : (
            <Button
              type="button"
              variant="primary"
              className="btn btn-primary"
              style={{ marginTop: 40, alignSelf: "flex-end" }}
              onClick={() => setShowCreateModal(true)}
            >
              Create App Config
            </Button>
          )}
        </Flex>
        <div className="notificationContainer">
          <Notification
            show={showToast}
            timer={4000}
            position="top-center"
            title={toastTitle}
            description={toastDescription}
            autohide={true}
            handleClose={handleNotificationClose}
            variant={toastVariant}
          />
        </div>
        <Modal
          enableModal={showUpdateModal}
          handleClose={handleCloseUpdateModal}
          handleSubmit={() => handleUpdateAppConfig()}
          title={"WARNING"}
          closeButtonText="Back"
          actionButtonText="Update"
        >
          Are you sure you want to update the application configuration?
          Disabling app functionality should only be done if absolutely
          neccessary.
        </Modal>
        <Modal
          enableModal={showCreateModal}
          handleClose={handleCloseCreateModal}
          handleSubmit={() => handleCreateAppConfig()}
          title={"WARNING"}
          closeButtonText="Back"
          actionButtonText="Create"
        >
          Double check the application configuration is correct before
          proceeding to create.
        </Modal>
      </div>
    </Container>
  );
}
